import React, { useEffect, useState } from "react";

import Footer from "../../components/shared/Footer";
import AttorneySelect from "../../components/shared/AttorneySelect";
import * as APIModels from "../../models";
import { DataService } from "../../services/DataService";
import Select from "react-select";
import { ActionMeta } from "react-select";
import { MatterService } from "../../services/ClientService";
import { Globals } from "../../helpers/globals";
import { KeyValueStore } from "./BetaTypes";

type NameValueOptionType = { label: string; value: string };

const partyTypeOptions = [
    {
        label: "Plaintiff",
        value: "9b13618b-22e8-47cb-90b2-7034aecb06bb",
    } as NameValueOptionType,
    {
        label: "Defendant",
        value: "eb701ab0-d199-454b-9712-d14b5365a06d",
    } as NameValueOptionType,
] as const;

export default function CreateMatterManagmentPage() {
    let options: NameValueOptionType[] = [];
    //const [newKeyValue, setNewKeyValue] = useState({} as KeyValueFormType);
    //const [keyValueStores, setKeyValueStores] = useState([] as KeyValueFormType[]);
    //
    const [firmId, setFirmId] = useState("");
    const [columns, setColumns] = useState(4);
    const [attorneyId, setAttorneyId] = useState("");
    const [attorneyName, setAttorneyName] = useState("");
    const [addingKeyValue, setAddingKeyValue] = useState(false);
    const [organizationId, setorganizationId] = useState(
        Globals.currentUserValue.organizationID
    );
    const [matterNumber, setMatterNumber] = useState("");
    const [countyOptions, setCountyOptions] = useState(options);
    const [countyId, setCountyId] = useState(APIModels.EmptyGuid);
    const [divisionOptions, setDivisionOptions] = useState(options);
    const [divisionId, setDivisionId] = useState(APIModels.EmptyGuid);
    const [counties, setCounties] = useState([] as APIModels.County[]);
    const [divisions, setDivisions] = useState([] as APIModels.Division[]);
    const [keyValueStore, setKeyValueStore] = useState<KeyValueStore>(
        {} as KeyValueStore
    );

    const addColumn = () => {
        const newCols = columns + 1;
        setColumns(newCols);
    };

    const onAttorneySelected = (id: string, name: string) => {
        setAttorneyId(id);
        setAttorneyName(name);
    };

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    const onCountyChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setKeyValueStore({
            ...keyValueStore,
            county: value?.label ?? "Alucha",
        });
    };

    const onDivisionChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setKeyValueStore({
            ...keyValueStore,
            division: value?.label ?? "Alucha",
        });
    };

    //const cancelNewKeyValueCreate = () => {
    //    setAddingKeyValue(false)
    //    setNewKeyValue({} as KeyValueFormType)
    //}

    //const addNewKeyValue = () => {
    //    addColumn()
    //    const updatedKeyValueStores = [...keyValueStores]
    //    updatedKeyValueStores.push(newKeyValue)
    //    setKeyValueStores(updatedKeyValueStores)
    //}

    const filterOption = (
        option: NameValueOptionType,
        inputValue: string
    ): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    useEffect(() => {
        MatterService.nextMatter({
            organizationId: organizationId ?? APIModels.EmptyGuid,
        }).then((res) => {
            if (res.data && res.successful) {
                console.log(res.data);
                setMatterNumber(res.data);
            } else {
                console.error(res.errorMessage);
            }
        });
    }, [organizationId]);

    useEffect(() => {
        DataService.getCountiesByPortal({ state: "FL" }).then(
            (resp) => {
                options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setCountyOptions(options);
                setCounties(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        DataService.getDivisions({ countyId: countyId }).then(
            (resp) => {
                options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setDivisionOptions(options);
                setDivisions(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [countyId]);

    const addNewMatter = () => {
        console.log(organizationId);
        MatterService.add({
            organizationId: organizationId ?? APIModels.EmptyGuid,
            body: { dynamoDbEntry: keyValueStore },
        }).then((res) => {
            if (res.successful && res.data) {
                window.location.href = "/matter-managment";
            } else {
                setMatterNumber(res.data ?? "");
                console.error(res.errorMessage ?? "unknown error");
            }
        });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Create New Matter</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="/dashboard"> eFileMadeEasy </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="/matter-managment">
                                            {" "}
                                            Matter Managment{" "}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        {" "}
                                        Create New Matter{" "}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <h3>
                                {" "}
                                Populate New Matter: <b>{matterNumber}</b>
                                <br />
                                <b>Complaint And Summons For Evictions</b>{" "}
                            </h3>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-sm-12"></div>
                            <label htmlFor="selCounty" className="form-label">
                                County/Court
                            </label>
                            <Select
                                id="selCounty"
                                name="selCounty"
                                value={countyOptions.filter(
                                    (c) => c.label === keyValueStore.county
                                )}
                                filterOption={filterOption}
                                options={countyOptions}
                                onChange={onCountyChange}
                            />
                        </div>
                        {countyId !== APIModels.EmptyGuid && (
                            <div className="row mb-3">
                                <label
                                    htmlFor="selDivision"
                                    className="form-label"
                                >
                                    Division
                                </label>
                                <Select
                                    id="selDivision"
                                    name="selDivision"
                                    value={divisionOptions.filter(
                                        (c) =>
                                            c.label === keyValueStore.division
                                    )}
                                    filterOption={filterOption}
                                    options={divisionOptions}
                                    onChange={onDivisionChange}
                                />
                            </div>
                        )}
                        <div className="row">
                            <div className="col-sm-4">
                                <span>
                                    <h3>Your Mergefields</h3>
                                </span>
                            </div>
                            <div className="col-sm-4"></div>
                            <div className="col-sm-4"></div>
                        </div>
                        <br />
                        <div className="row">
                            <table className="table table-striped">
                                <thead>
                                    <td>Mergefield Identifier</td>
                                    <td>Mergefield Value</td>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Plaintiff</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="plaintiff"
                                                placeholder="Edward Finneas Michaels Esq."
                                                aria-describedby="plaintiff"
                                                value={keyValueStore.plaintiff}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        plaintiff:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Defendant (1)</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="def-1"
                                                placeholder="Lawrence A. Schmitt"
                                                aria-describedby="def-1"
                                                value={keyValueStore.def1}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        def1: event
                                                            .currentTarget
                                                            .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Defendant (2)</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="def-2"
                                                placeholder="Lawrence A. Schmitt"
                                                aria-describedby="def-2"
                                                value={keyValueStore.def2}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        def2: event
                                                            .currentTarget
                                                            .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Defendant (3)</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="def-3"
                                                placeholder="Lawrence A. Schmitt"
                                                aria-describedby="def-3"
                                                value={keyValueStore.def3}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        def3: event
                                                            .currentTarget
                                                            .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Tenant Address</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="tenant-address"
                                                placeholder="1101 N. Armenia St. N"
                                                aria-describedby="tenant-address"
                                                value={
                                                    keyValueStore.tenantAddress
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        tenantAddress:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Bar Number</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtBarNumber"
                                                placeholder="111XXX"
                                                aria-describedby="txtBarNumber"
                                                value={keyValueStore.barNumber}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        barNumber:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Case Number</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtCaseNumber"
                                                placeholder="24-XXXX-SC"
                                                aria-describedby="txtCaseNumber"
                                                value={keyValueStore.caseNumber}
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        caseNumber:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Monthly Rent</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtmonthlyRent"
                                                placeholder="3333"
                                                aria-describedby="txtmonthlyRent"
                                                value={
                                                    keyValueStore.monthlyRent
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        monthlyRent:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Contract Type</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtContractType"
                                                placeholder="'month to month' or 'written'"
                                                aria-describedby="txtContractType"
                                                value={
                                                    keyValueStore.contractType
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        contractType:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>E Signature</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="eSigAttorney"
                                                placeholder="Edward Finneas Michaels Esq."
                                                aria-describedby=""
                                                value={
                                                    keyValueStore.eSigAttorney
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        eSigAttorney:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Rental Period</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="rentalPeriod"
                                                placeholder="month"
                                                aria-describedby="rentalPeriod"
                                                value={
                                                    keyValueStore.rentalPeriod
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        rentalPeriod:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Periods/Months Rent Due</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="monthsRentIsDue"
                                                placeholder="August, September, and October"
                                                aria-describedby="monthsRentIsDue"
                                                value={
                                                    keyValueStore.monthsRentIsDue
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        monthsRentIsDue:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Civil Cover Sheeet</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="civilCoverSheet"
                                                placeholder="E-Finneas-Micheals-Evictions.docm"
                                                aria-describedby="civilCoverSheet"
                                                value={
                                                    keyValueStore.civilCoverSheet
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        civilCoverSheet:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Date Complaint Filed</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="dateComplaintFiled"
                                                placeholder="November 17, 2024"
                                                aria-describedby="dateComplaintFiled"
                                                value={
                                                    keyValueStore.dateComplaintFiled
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        dateComplaintFiled:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>Date 3 Day Notice Served</b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="date3DayNoticeServed"
                                                placeholder="November 17, 2024"
                                                aria-describedby="date3DayNoticeServed"
                                                value={
                                                    keyValueStore.date3DayNoticeServed
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        date3DayNoticeServed:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>
                                                    Default/Motion Strike Date
                                                </b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="defaultMotionStrikeDate"
                                                placeholder="November 17, 2024"
                                                aria-describedby="defaultMotionStrikeDate"
                                                value={
                                                    keyValueStore.defaultMotionStrikeDate
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        defaultMotionStrikeDate:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>
                                                    Date Complaint Mailed Filed
                                                </b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="dateComplaintMailedFiled"
                                                placeholder="November 17, 2024"
                                                aria-describedby="dateComplaintMailedFiled"
                                                value={
                                                    keyValueStore.dateComplaintMailedFiled
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        dateComplaintMailedFiled:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>
                                                <b>
                                                    Unpaid Rent Amount On Notice
                                                </b>
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="unpaidRentAmountOnNotice"
                                                placeholder="10000"
                                                aria-describedby=""
                                                value={
                                                    keyValueStore.unpaidRentAmountOnNotice
                                                }
                                                onChange={(event) =>
                                                    setKeyValueStore({
                                                        ...keyValueStore,
                                                        unpaidRentAmountOnNotice:
                                                            event.currentTarget
                                                                .value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-12 col-sm-6 float-right">
                                <button
                                    type="button"
                                    className="btn btn-success float-right"
                                    onClick={addNewMatter}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export function PartySection() {
    const [parties, setParties] = useState([] as APIModels.Party[]);
    const [addingParty, setAddingParty] = useState(false);
    const [newPartyIsOrg, setNewPartyIsOrg] = useState(false);
    const [newParty, setNewParty] = useState({} as APIModels.Party);

    const onNewPartyTypeChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setNewParty({
            ...newParty,
            partyType: value?.label ?? "Plaintiff",
        });
    };

    const filterOption = (
        option: NameValueOptionType,
        inputValue: string
    ): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <>
            <div className="row">
                <div className="col-sm-4">
                    <span>
                        <h3>Associated Parties</h3>
                    </span>
                </div>
                <div className="col-sm-4"></div>
                <div className="col-sm-4">
                    {addingParty ? (
                        <button
                            type="button"
                            className="btn btn-primary float-right"
                            onClick={() => {
                                const updatedParties = [...parties];
                                updatedParties.push(newParty);
                                setParties(updatedParties);
                                setAddingParty(false);
                            }}
                        >
                            {" "}
                            Save{" "}
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-primary float-right"
                            onClick={() => {
                                setAddingParty(true);
                            }}
                        >
                            {" "}
                            Add Party{" "}
                        </button>
                    )}
                </div>
            </div>
            <br />
            <div className="row mb-3">
                {!newPartyIsOrg ? (
                    <div className="row mb-3">
                        <div className="col-sm-4">
                            <label
                                htmlFor="txtMergeField"
                                className="form-label"
                            >
                                First Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtMergeField"
                                    placeholder="def-1"
                                    aria-describedby="inputGroupPrepend"
                                    value={newParty.firstName}
                                    onChange={(event) =>
                                        setNewParty({
                                            ...newParty,
                                            firstName: event.target.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <label
                                htmlFor="txtNewPartyName"
                                className="form-label"
                            >
                                Last Name
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtNewPartyName"
                                    placeholder="John Doe"
                                    aria-describedby="inputGroupPrepend"
                                    value={newParty.lastName}
                                    onChange={(event) =>
                                        setNewParty({
                                            ...newParty,
                                            lastName: event.target.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <button
                                className="btn btn-primary"
                                onClick={() => setNewPartyIsOrg(true)}
                            >
                                {" "}
                                New Party Is Organization{" "}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-sm-8">
                            <label
                                htmlFor="txtOrganization"
                                className="form-label"
                            >
                                Organization
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtOrganization"
                                    placeholder="John Doe"
                                    aria-describedby="inputGroupPrepend"
                                    value={newParty.name}
                                    onChange={(event) =>
                                        setNewParty({
                                            ...newParty,
                                            name: event.target.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <button
                                className="btn btn-primary"
                                onClick={() => setNewPartyIsOrg(false)}
                            >
                                {" "}
                                New Party Is Organization{" "}
                            </button>
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-sm-4">
                        <label
                            htmlFor="partyAddressPhoneNumber"
                            className="form-label"
                        >
                            Phone Number
                        </label>
                        <div className="input-group">
                            <input
                                type="tel"
                                className="form-control"
                                id="partyAddressPhoneNumber"
                                placeholder="+1 (800) 555-3141"
                                aria-describedby="partyAddressPhoneNumber"
                                value={newParty.phoneNumber}
                                onChange={(event) =>
                                    setNewParty({
                                        ...newParty,
                                        phoneNumber: event.currentTarget.value,
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="partyAddressStreet"
                            className="form-label"
                        >
                            Street Address
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="partyAddressStreet"
                                placeholder="1101 N Armenia St. N"
                                aria-describedby="inputGroupPrepend"
                                value={newParty.address?.streetAddress}
                                onChange={(event) =>
                                    setNewParty({
                                        ...newParty,
                                        address: {
                                            ...newParty.address,
                                            streetAddress:
                                                event.currentTarget.value,
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="partyAddressUnit"
                            className="form-label"
                        >
                            Unit Number
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="partyAddressUnit"
                                placeholder="4204"
                                aria-describedby="inputGroupPrepend"
                                value={newParty.address?.unit}
                                onChange={(event) =>
                                    setNewParty({
                                        ...newParty,
                                        address: {
                                            ...newParty.address,
                                            unit: event.currentTarget.value,
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <label
                            htmlFor="partyAddressPhoneNumber"
                            className="form-label"
                        >
                            City
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="partyAddressCity"
                                placeholder="+1 (800) 555-3141"
                                aria-describedby="partyAddressCity"
                                value={newParty.address?.city}
                                onChange={(event) =>
                                    setNewParty({
                                        ...newParty,
                                        address: {
                                            ...newParty.address,
                                            city: event.currentTarget.value,
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="selNewPartyType" className="form-label">
                            State
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="partyAddressStreet"
                                placeholder="1101 N Armenia St. N"
                                aria-describedby="inputGroupPrepend"
                                value={newParty.address?.state}
                                onChange={(event) =>
                                    setNewParty({
                                        ...newParty,
                                        address: {
                                            ...newParty.address,
                                            state: event.currentTarget.value,
                                        },
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="selNewPartyType" className="form-label">
                            Party Type
                        </label>
                        <Select
                            id="selNewPartyType"
                            name="selNewPartyType"
                            value={partyTypeOptions.filter(
                                (c) => c.label === newParty.partyType
                            )}
                            filterOption={filterOption}
                            options={partyTypeOptions}
                            onChange={onNewPartyTypeChange}
                        />
                    </div>
                </div>
                <br />
                <div className="row">
                    <table className="table table-striped">
                        <thead></thead>
                        <tbody>
                            {parties.map((party, index) => (
                                <React.Fragment key={index}>
                                    <tr></tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <hr />
        </>
    );
}
